/* Giftaty — gift details step before checkout.
   Checkout buttons in the cart drawer / cart page open /pages/gift-details,
   which saves the choices as cart attributes (order "Additional details") and continues to checkout. */
(function () {
  if (window.__ggGiftOpts) return;
  window.__ggGiftOpts = true;

  var AR = (document.documentElement.lang || '').indexOf('ar') === 0;
  var T = AR
    ? { name: 'يرجى إدخال اسم المستلم.', phone: 'يرجى إدخال رقم هاتف صحيح للمستلم.', save: 'تعذّر حفظ خيارات الهدية، حاول مرة أخرى.' }
    : { name: "Please enter the recipient's name.", phone: 'Please enter a valid phone number for the recipient.', save: "We couldn't save your gift options. Please try again." };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var STEP_URL = root + 'pages/gift-details';
  var timer = null;

  function q(box, k) { return box.querySelector('[data-gg="' + k + '"]'); }
  function digits(v) { return (v || '').replace(/\D/g, ''); }
  function normPhone(code, v) { var d = digits(v); if (code === '+20' && d.charAt(0) === '0') d = d.slice(1); return d; }

  function read(box) {
    var unknown = q(box, 'unknown').checked;
    var code = q(box, 'code').value;
    var num = normPhone(code, q(box, 'phone').value);
    var name = (q(box, 'name').value || '').trim();
    return {
      unknown: unknown, name: name, code: code, num: num,
      attrs: {
        'Keep Sender Identity Secret': q(box, 'secret').checked ? 'Yes' : 'No',
        'Recipient Address Unknown': unknown ? 'Yes' : 'No',
        'Recipient Name': unknown ? name : '',
        'Recipient Phone': unknown && num ? code + ' ' + num : ''
      }
    };
  }

  function save(box) {
    box.classList.add('is-saving');
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: read(box).attrs })
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .finally(function () { box.classList.remove('is-saving'); });
  }

  function queue(box) {
    clearTimeout(timer);
    timer = setTimeout(function () { save(box).catch(function () {}); }, 450);
  }

  function setErr(box, k, msg) {
    var el = box.querySelector('[data-gg-error="' + k + '"]');
    if (el) el.textContent = msg || '';
    var f = el && el.closest('.gg-field');
    if (f) f.classList.toggle('is-invalid', !!msg);
    var inp = q(box, k);
    if (inp) inp.setAttribute('aria-invalid', msg ? 'true' : 'false');
  }

  function validate(box) {
    var s = read(box), ok = true, first = null;
    setErr(box, 'name'); setErr(box, 'phone');
    if (!s.unknown) return true;
    if (s.name.length < 2) { setErr(box, 'name', T.name); ok = false; first = first || q(box, 'name'); }
    var validPhone = s.code === '+20' ? /^1\d{9}$/.test(s.num) : s.num.length >= 7 && s.num.length <= 14;
    if (!validPhone) { setErr(box, 'phone', T.phone); ok = false; first = first || q(box, 'phone'); }
    if (first) { first.focus(); first.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    return ok;
  }

  /* Gift options interactions (on the gift details page) */
  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-gg-opts]');
    if (!box) return;
    if (e.target.matches('[data-gg="unknown"]')) {
      box.querySelector('[data-gg-recipient]').hidden = !e.target.checked;
      if (e.target.checked) setTimeout(function () { q(box, 'name').focus(); }, 50);
      else { setErr(box, 'name'); setErr(box, 'phone'); }
    }
    queue(box);
  });

  document.addEventListener('input', function (e) {
    var box = e.target.closest && e.target.closest('[data-gg-opts]');
    if (!box) return;
    if (e.target.matches('[data-gg="name"],[data-gg="phone"]')) { setErr(box, e.target.getAttribute('data-gg')); queue(box); }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    /* "Continue to checkout" on the gift details page */
    var cont = e.target.closest('[data-gg-continue]');
    if (cont) {
      e.preventDefault();
      var box = document.querySelector('[data-gg-opts]');
      if (!box) { window.location.href = root + 'checkout'; return; }
      if (!validate(box)) return;
      clearTimeout(timer);
      cont.disabled = true;
      cont.setAttribute('aria-busy', 'true');
      save(box)
        .then(function () { window.location.href = root + 'checkout'; })
        .catch(function () { cont.disabled = false; cont.removeAttribute('aria-busy'); alert(T.save); });
      return;
    }

    /* Theme checkout buttons (cart drawer / cart page) → gift details step first */
    var btn = e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (btn && !btn.disabled) {
      e.preventDefault();
      e.stopImmediatePropagation();
      btn.setAttribute('aria-busy', 'true');
      window.location.href = STEP_URL;
    }
  }, true);
})();